import { render, staticRenderFns } from "./MSA.vue?vue&type=template&id=3ab43fce&scoped=true"
import script from "./MSA.vue?vue&type=script&lang=js"
export * from "./MSA.vue?vue&type=script&lang=js"
import style0 from "./MSA.vue?vue&type=style&index=0&id=3ab43fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab43fce",
  null
  
)

export default component.exports